import React from 'react'
import { IndexRoute, Router, Route } from 'react-router'
import Layout from 'src/layouts/Layout'
import Home from './Home'
import NotFound from './NotFound'

const routes = () => {

  return (
    <Router>
      <Route component={Layout} path="/">
        <IndexRoute component={Home} title="home" />
        <Route path="*" component={NotFound} title="not-found" />
      </Route>
    </Router>
  )
}

export default routes
